<header class="estudio-sidenav--header">
    <div class="estudio-sidenav--arrow">
        <button mat-icon-button class="no-hover-effect menu" (click)="closeEndRightSidenav($event)">
            <mat-icon>arrow_forward</mat-icon>
        </button>

    </div>

</header>